import styled, { css } from 'styled-components'
import { device, WarOffset } from '../../../styles/GlobalVariables'
import AdClose from '/public/assets/images/svg/ad-close.svg'
import { adPlacementTextCss } from '../AdPlacementCss'

const topPlacement = ({
  bg,
  isLiveVod,
  isVod,
  dfpIsBlocked,
  firstEntrance,
}: {
  bg: string
  isLiveVod?: boolean
  isVod?: boolean
  dfpIsBlocked?: boolean
  firstEntrance?: boolean
}) => css`
  position: relative;
  ${isVod
    ? ''
    : css`
        border-bottom: 1px solid #dfdfdf;
      `}
  ${dfpIsBlocked
    ? 'display: none;'
    : css`
        min-height: ${firstEntrance ? '410px' : '200px'};
      `}
  background-color: ${bg};
  transition: height 0.5s ease;

  > div {
    transition: height 0.5s ease;
  }

  ${device.medium} {
    min-height: ${dfpIsBlocked ? 0 : 290}px;
    ${!isLiveVod
      ? css`
          margin-bottom: 28px;
        `
      : ''};
  }

  ${adPlacementTextCss}
`

export const Container = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${props =>
    topPlacement({
      bg: props.theme.isVod ? '#1e1e1e' : '#f8f8f8',
      isLiveVod: !!props.theme.isLive,
      isVod: props.theme.isVod,
      dfpIsBlocked: props.theme.dfpIsBlocked,
      firstEntrance: props.theme.firstEntrance,
    })}
  ${props => WarOffset(props.theme.haseWarComp, true)}

  > div {
    position: relative;
    z-index: 1;
  }
`

export const InboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100vw;
  max-width: 1280px;
`

export const AdCloseIcon = styled(AdClose)`
  position: absolute;
  font-size: 38px;
  top: 10px;
  left: 10px;
  z-index: 1;
  cursor: pointer;
`
